export default function ToggleSet({ translations }: { translations: any }) {
  return (
    <div className="mb-4 shadow-sm">
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSc_fp0OXbO-WhlN_O37BnkgZIaFb9-6lTUf91qOMIWw_vVfhA/viewform?usp=sf_link"
        target="_blank"
        rel="noopener noreferrer"
        className="flex cursor-pointer justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] py-4 text-sm font-bold text-[#3796F6] sm:rounded-lg"
      >
        {translations.contentRequest}
      </a>
    </div>
  );
}
